import styled from "styled-components";

export const Container = styled.div``;

export const OneLine = styled.div`
  display: flex;
`;
